import React from 'react';

export function PageTransition({ children }) {
  return (
    <div className="page-transition-enter">
      {children}
    </div>
  );
}
